import * as types from 'state/redux/constants'

const initialState = {
  drawer: true,
  toggles: [],
  /** When set, super-company API calls include this branch (see apiGet + backend `branchId`). */
  companyBranchFilterId: null,
}

const settingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_DRAWER_TOGGLE:
      return {
        ...state,
        drawer: action.data,
      }

    case types.SET_MENU_TOGGLES:
      return {
        ...state,
        toggles: action.data,
      }

    case types.SET_MAIN_MENU_TOGGLES:
      return {
        ...state,
        mainToggles: action.data,
      }

    case types.SET_COMPANY_BRANCH_FILTER:
      return {
        ...state,
        companyBranchFilterId: action.data,
      }

    default:
      return state
  }
}

export default settingsReducer
